import React from 'react';

import MuiPhoneInput from 'material-ui-phone-number';

// TODO maybe we should use this: https://www.npmjs.com/package/react-phone-input-2
// MuiPhoneInput scheint etwas langsam zu sein und ist buggy!
// 

import {
    Translate,
} from "src/shared_modules/i18n";


const PhoneInput = (props) => {

    return( <MuiPhoneInput id="phone"
                defaultCountry={"de"}
                regions={["north-america", "europe", "asia"]}
                variant="outlined"
                disableAreaCodes={true}
                autoFormat={false}
                fullWidth
                label={<Translate>person-labels.phone</Translate>}
                required={props.required}
                disabled={props.disabled}
                value={props.value}
                error={props.error}
                onChange={props.onChange}
                style={props.style}
                className={props.className}
            />);
}

export default PhoneInput;
